import { IoClose } from 'react-icons/io5';
import { useRef, useEffect } from "react";

interface DrawerProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    title: string;
    children: React.ReactNode;
    canClose?: boolean;
}

const Drawer: React.FC<DrawerProps> = ({ open, setOpen, title, children, canClose = true }) => {
    const drawerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target as Node) && canClose) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open, setOpen, canClose]);

    return (
        <div className={`fixed inset-0 z-10 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div 
                className={`fixed inset-0 bg-black transition-opacity duration-300 ${open ? 'bg-opacity-25' : 'bg-opacity-0'}`} 
            />

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                        <div 
                            ref={drawerRef}
                            className={`pointer-events-auto w-screen max-w-2xl transform transition-transform duration-300 ease-in-out ${
                                open ? 'translate-x-0' : 'translate-x-full'
                            }`}
                        >
                            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                <div className="px-4 py-6 sm:px-6">
                                    <div className="flex items-start justify-between">
                                        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
                                        {canClose && <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                onClick={() => setOpen(false)}
                                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <IoClose aria-hidden="true" className="size-6" />
                                            </button>
                                        </div>}
                                    </div>
                                </div>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drawer; 